import type { KeyboardEvent } from 'react'
import type { DataGridProps, GridRowParams } from '@mui/x-data-grid'
import { CLICKABLE_ROW_CLASS_NAME } from 'shared/constants/clickableRows'
import { isEnterOnRow, isTextSelected } from './rowClick'

export type DataGridRowTarget<R = any> = Pick<GridRowParams<R>, 'id' | 'row'>

type DataGridRowClickProps = Required<
  Pick<DataGridProps, 'onRowClick' | 'getRowClassName' | 'componentsProps'>
>

const isAlwaysClickable = () => true

// The grid keeps a single tab stop for all cells, so rows get their own to
// let Tab walk the list. Enter on a row or one of its cells replays a row
// click, which runs the same checks as a mouse click.
const rowKeyboardProps = {
  tabIndex: 0,
  onKeyDown: (event: KeyboardEvent<HTMLElement>) => {
    if (isEnterOnRow(event)) event.currentTarget.click()
  },
}

// The grid itself skips row clicks coming from "actions" columns and portals
// (row menu, confirm dialog), so only clicks on regular cells land here.
export const getDataGridRowClickProps = (
  onRowClick: (target: DataGridRowTarget) => void,
  isRowClickable: (target: DataGridRowTarget) => boolean = isAlwaysClickable
): DataGridRowClickProps => ({
  onRowClick: params => {
    if (isRowClickable(params) && !isTextSelected()) onRowClick(params)
  },
  getRowClassName: params =>
    isRowClickable(params) ? CLICKABLE_ROW_CLASS_NAME : '',
  componentsProps: { row: rowKeyboardProps },
})
